import React from 'react';
import ModalShell from '../../components/modals/ModalShell';
import { FavouriteIcon } from '@tymbe/ui-icons';
import { PrimaryButton } from '@tymbe/ui-primitives/*';
import { AdminPopup, AdminPopupImageEnum } from '@tymbe/schema/admin-popup.interface';
import Markdown from 'markdown-to-jsx';
import TymbeEarImage from '../../assets/images/popup/tymbe_ear.png';
import TymbeHeartImage from '../../assets/images/popup/tymbe_heart.png';
import TymbeSosImage from '../../assets/images/popup/tymbe_sos.png';
import TymbeThumbsUpImage from '../../assets/images/popup/tymbe_thumbs_up.png';
import TymbeTrophyImage from '../../assets/images/popup/tymbe_trophy.png';

interface AdminPopupModalProps {
  showPopup: boolean;
  popupData: AdminPopup | null;
  handleClosePopup: () => void;
}

// New component for popup content
interface AdminPopupContentProps {
  popupData: Omit<AdminPopup, 'created_at' | 'updated_at'>;
  handleClosePopup: () => void;
}

const getPopupImage = (image: AdminPopupImageEnum) => {
  switch (image) {
    case AdminPopupImageEnum.ear:
      return TymbeEarImage;
    case AdminPopupImageEnum.heart:
      return TymbeHeartImage;
    case AdminPopupImageEnum.sos:
      return TymbeSosImage;
    case AdminPopupImageEnum.thumbsUp:
      return TymbeThumbsUpImage;
    case AdminPopupImageEnum.trophy:
      return TymbeTrophyImage;
    default:
      return TymbeThumbsUpImage;
  }
};

export const AdminPopupContent = ({ popupData, handleClosePopup }: AdminPopupContentProps) => {
  return <div className="flex flex-col gap-6 items-center h-full">
    <img src={getPopupImage(popupData.image)} alt="Admin popup illustration" className="w-56 h-56" />
    <div className="overflow-scroll max-h-72">
      <Markdown className="reset-all [&_*]:reset-all">{popupData.content}</Markdown>
    </div>
    {popupData.button_url ? (
      <a
        href={popupData.button_url}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-primary-200 text-center block rounded-[80px] !text-fg-900 w-fit"
      >
        <PrimaryButton onClick={handleClosePopup}>{popupData.button_text}</PrimaryButton>
      </a>
    ) : null}
  </div>
};

const AdminPopupModal = ({ showPopup, popupData, handleClosePopup }: AdminPopupModalProps) => (
  <ModalShell showModal={showPopup} onClose={handleClosePopup} className="px-6 max-w-[550px] w-full pb-10 pt-0">
    {popupData && (
      <div className="flex flex-col w-full">
        <div className="flex h-14 items-center">
          <FavouriteIcon name="close" className="h-6 w-6 cursor-pointer ml-auto my-auto" onClick={handleClosePopup} />
        </div>
        <AdminPopupContent popupData={popupData} handleClosePopup={handleClosePopup} />
      </div>
    )}
  </ModalShell>
);

export default AdminPopupModal;
